// Reducers
import { combineReducers } from '@reduxjs/toolkit'

import data from './providersDataReducer'
import providerDetails from '../individualProvider/data/providerDetailsReducer'
import register from '../register/data/registerProviderReducer'

export default combineReducers({
  providerDetails,
  register,
  data,
})
